// extracted by mini-css-extract-plugin
module.exports = {"root":"az_DT","input":"az_ET","toggle-background":"az_FT","toggle-knob":"az_GT"};